import {
  Container,
  Divider,
  PlanContainer,
  PlanDescription,
  PlanDescriptionLabelContainer,
  TitleContainer,
  VerticalContainer,
} from "./ServicePlanCard.styles";
import UI from "@mile-meeting/mile-ui";
import React from "react";
import { getKorDate } from "utils/date";
import { Plan, ServiceName, ServicePlanCardProps } from "./types";

const ServicePlanCard: React.FC<ServicePlanCardProps> = (props) => {
  const {
    serviceName,
    plan,
    usedTablet,
    planStartedAt,
    planEndedAt,
    enableMeetingRoom = 0,
    usingMeetingRoom = 0,
  } = props;

  return (
    <Container>
      <VerticalContainer>
        <TitleContainer>
          <UI.Icon
            name={serviceName === ServiceName.MEETING ? "meetingRoom2" : "people"}
            size={40}
            color="var(--alias-color-primary-normal)"
          />
          <UI.Typography type="heading02" fontStyle="bold" color="var(--alias-color-label-normal)">
            {serviceName}
          </UI.Typography>
        </TitleContainer>

        {plan ? (
          <PlanContainer>
            <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-normal)">
              {plan} 플랜
            </UI.Typography>
            {serviceName === ServiceName.MEETING && plan === Plan.BASIC && (
              <UI.Tag
                label={usedTablet ? "태블릿 사용" : "태블릿 미사용"}
                type="primary"
                color={usedTablet ? "blue" : "gray"}
                size="small"
              />
            )}
          </PlanContainer>
        ) : (
          <UI.Typography type="body01 normal" fontStyle="medium" color="var(--alias-color-label-alternative)">
            이용 중인 플랜 없음
          </UI.Typography>
        )}

        <Divider />
        <PlanDescription>
          <PlanDescriptionLabelContainer>
            <UI.Typography color="var(--alias-color-label-normal)" type="label01" fontStyle="regular">
              플랜 이용 기간:
            </UI.Typography>
            <UI.Typography color="var(--alias-color-label-normal)" type="label01" fontStyle="regular">
              {planStartedAt ? getKorDate(planStartedAt).replaceAll(".", ". ") : ""} -{" "}
              {planEndedAt ? getKorDate(planEndedAt).replaceAll(".", ". ") : ""}
            </UI.Typography>
          </PlanDescriptionLabelContainer>
          {serviceName === ServiceName.MEETING && (
            <PlanDescriptionLabelContainer>
              <UI.Typography color="var(--alias-color-label-normal)" type="label01" fontStyle="regular">
                생성 가능 회의실 수:
              </UI.Typography>
              <UI.Typography color="var(--alias-color-label-normal)" type="label01" fontStyle="medium">
                {usingMeetingRoom ?? 0}개
              </UI.Typography>
              <UI.Typography color="var(--alias-color-label-alternative)" type="label01" fontStyle="regular">
                /
              </UI.Typography>
              <UI.Typography color="var(--alias-color-label-alternative)" type="label01" fontStyle="regular">
                {enableMeetingRoom ?? 0}개
              </UI.Typography>
            </PlanDescriptionLabelContainer>
          )}
        </PlanDescription>
      </VerticalContainer>
    </Container>
  );
};

export default React.memo(ServicePlanCard);
